module.exports = __webpack_public_path__ + "img/5.1d451d27.png";